var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 1.66699V3.33366",
    stroke: "#E10C3C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 1.66699V3.33366",
    stroke: "#E10C3C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66699C13.5543 6.66699 13.7663 6.75479 13.9226 6.91107C14.0789 7.06735 14.1667 7.27931 14.1667 7.50033V14.167C14.1667 15.051 13.8155 15.8989 13.1904 16.524C12.5652 17.1491 11.7174 17.5003 10.8333 17.5003H5.83333C4.94928 17.5003 4.10143 17.1491 3.47631 16.524C2.85119 15.8989 2.5 15.051 2.5 14.167V7.50033C2.5 7.27931 2.5878 7.06735 2.74408 6.91107C2.90036 6.75479 3.11232 6.66699 3.33333 6.66699H15C15.8841 6.66699 16.7319 7.01818 17.357 7.6433C17.9821 8.26842 18.3333 9.11627 18.3333 10.0003C18.3333 10.8844 17.9821 11.7322 17.357 12.3573C16.7319 12.9825 15.8841 13.3337 15 13.3337H14.1667",
    stroke: "#E10C3C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.66699V3.33366",
    stroke: "#E10C3C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeep);
export default __webpack_public_path__ + "static/media/coffeep.aa2d8ac34003300951a71c7eefc38863.svg";
export { ForwardRef as ReactComponent };